const portfolio = {
    color: `text`,
    textDecoration: `none`,
    fontWeight: `medium`,
    userSelect: `none`,
    cursor: `pointer`,
    ':hover': {
      color: 'alpha'
    }
  }
  
  export default portfolio